export default __webpack_public_path__ + "static/media/Profile.12b8e7c1.svg";